import { useMemo } from 'react';
import { useSociety } from '@/features/societies/hooks/useSocieties';
import { useAuthStore } from '@/Stores/auth-v2-store';
import { getVendorWording, type VendorWording } from '@/utils/vendorWording';

/**
 * Wording dynamique base sur une societe specifique
 */
export function useVendorWording(societyId: string | undefined): VendorWording {
  const { data: society } = useSociety(societyId);
  return useMemo(() => getVendorWording(society?.vendorType), [society?.vendorType]);
}

/**
 * Wording dynamique base sur la societe de l'utilisateur connecte
 * Utile pour les elements globaux (Sidebar, pages de liste)
 */
export function useCurrentUserWording(): VendorWording {
  const { currentUser } = useAuthStore();
  const societyId = currentUser?.type === 'EXTERNAL' ? currentUser.societyId : undefined;
  const { data: society } = useSociety(societyId || '');
  return useMemo(() => getVendorWording(society?.vendorType), [society?.vendorType]);
}
